import { localized } from "@blocks/utils";
import { addFilter } from "@wordpress/hooks";

const magazineTemplateBlocks = [
	"category",
	"archive",
	"breadcrumbs",
	"post-content",
	"post-meta",
	"post-title",
	"post-image",
];

const disableBlocks = () => {
	addFilter(
		"magazine-blocks.block.metadata",
		"magazine-blocks/disable-blocks",
		(metadata) => {
			const [namespace, name] = metadata.name.split("/");
			if (magazineTemplateBlocks.includes(name)) {
				metadata.supports = {
					...metadata.supports,
					inserter:
						(window as any).magazinePostTypeSettings?.postType ===
						"mzb-builder-template",
					html: false,
				};
			} else {
				const enabled = localized.configs.blocks[name];
				if (!enabled) {
					if (typeof metadata.supports === "undefined") {
						metadata.supports = {};
					}
					metadata.supports.inserter = false;
				}
			}

			return metadata;
		}
	);
};

export default disableBlocks;
